import {
    getModificationTime,
    insertInto,
    setModificationTime,
} from "../utils/LokiUtils";
import lokiDB from "./lokiDB";

class EconomyDB {
    getModificationTime(FarmID) {
        return getModificationTime("economy", "FarmID", FarmID);
    }

    /**
     * Data modyfikacji trzymana jest per ferma - patrz komentarz w salesDB.insertSales
     * @param values tablica danych ekonomicznych
     */
    insertEconomy(values) {
        values.sort((e1, e2) => e1.DtaModTime - e2.DtaModTime);
        insertInto(values, lokiDB.economy, "EID");
        const newest = values[values.length - 1];
        setModificationTime(
            "economy",
            newest.DtaModTime,
            "FarmID",
            newest.FarmID
        );
    }

    getEconomy(FarmID) {
        return lokiDB.economy.find({
            FarmID,
            DtaDelTime: {$type: "undefined"},
        });
    }
}

const economyDB = new EconomyDB();
export default economyDB;
